webpackJsonp([165507533935187],{

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Code = function (_React$Component) {
	    _inherits(Code, _React$Component);
	
	    function Code() {
	        _classCallCheck(this, Code);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    Code.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'post' },
	            _react2.default.createElement(_reactHelmet2.default, { title: 'Code' }),
	            _react2.default.createElement(
	                'h2',
	                null,
	                'Code'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'I will update this section as I get time to post various coding projects I have worked on. There is no fixed language these are written in . The projects exhibit the nature of my interests at different points of time. My current interests are on the side of web design and development.I have a code base for the following languages with varying project interests:'
	            ),
	            _react2.default.createElement(
	                'h4',
	                null,
	                'Javascript'
	            ),
	            _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: '/sandbox/recent-tweets/' },
	                        'Recent Tweets'
	                    ),
	                    ' built using YQL and YUI3'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: '/sandbox/scroll-to-bottom.html' },
	                        'NYTimes style related article waypoint'
	                    ),
	                    ' built using YUI3'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'a',
	                        { href: '/sandbox/yui-spinner/' },
	                        'CSS Spinner Image'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'h4',
	                null,
	                _react2.default.createElement(
	                    'a',
	                    { href: 'https://github.com/akshayp/assembly' },
	                    'Assembly'
	                )
	            ),
	            _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'Parity Checker'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'Icon Matcher(potentially image matcher)'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'Puzzle Matcher'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'Background Finder'
	                )
	            ),
	            _react2.default.createElement(
	                'h4',
	                null,
	                _react2.default.createElement(
	                    'a',
	                    { href: 'https://github.com/akshayp/cplusplus' },
	                    'C/C++'
	                )
	            ),
	            _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'Parity Checker'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'Icon Matcher'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'Ball Tracker'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'Prime Number Threading'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'Matlab in C++'
	                )
	            ),
	            _react2.default.createElement(
	                'h4',
	                null,
	                _react2.default.createElement(
	                    'a',
	                    { href: 'https://github.com/akshayp/vhdl' },
	                    'VHDL'
	                )
	            ),
	            _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'MIPS Processor'
	                    ),
	                    ' with forwarding and branch hazard control'
	                ),
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'Ping Pong'
	                    ),
	                    ' game designed for an Altera Chipset'
	                )
	            )
	        );
	    };
	
	    return Code;
	}(_react2.default.Component);
	
	exports.default = Code;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-code-js-177ca963576ed896a8bc.js